import * as Constants from '../constants/action-constants';
import { AliasVmid } from '../types/Common';
import { License, Certificate, Password } from 'vrlcm-gui-types';

export interface RequestLicenses {
  type: Constants.REQUEST_LICENSES;
  payload: {
    legacyOnly?: boolean;
  };
}

export interface RequestLicensesSuccess {
  type: Constants.REQUEST_LICENSES_SUCCESS;
  payload: {
    licenses: License[];
  };
}

export interface RequestLicensesFailed {
  type: Constants.REQUEST_LICENSES_FAILED;
}

export interface RequestPasswords {
  type: Constants.REQUEST_PASSWORDS;
}

export interface RequestPasswordsSuccess {
  type: Constants.REQUEST_PASSWORDS_SUCCESS;
  payload: {
    passwords: Password[];
  };
}

export interface RequestPasswordsFailed {
  type: Constants.REQUEST_PASSWORDS_FAILED;
}

export interface RequestCertificates {
  type: Constants.REQUEST_CERTIFICATES;
}

export interface RequestTenants {
  type: Constants.REQUEST_TENANTS;
  payload: {
    environmentId: string;
    productId: string;
  };
}

export interface RequestTenantsSuccess {
  type: Constants.REQUEST_TENANTS_SUCCESS;
  payload: {
    tenants: string[];
  };
}
export interface RequestTenantsFailed {
  type: Constants.REQUEST_TENANTS_FAILED;
}

export interface RequestCertificatesSuccess {
  type: Constants.REQUEST_CERTIFICATES_SUCCESS;
  payload: {
    certificates: AliasVmid[];
  };
}

export interface RequestCertificatesFailed {
  type: Constants.REQUEST_CERTIFICATES_FAILED;
}

export interface AddPassword {
  type: Constants.ADD_PASSWORD;
  payload: {
    password: Password;
  };
}

export interface AddPasswordSuccess {
  type: Constants.ADD_PASSWORD_SUCCESS;
  payload: {
    password: Password;
  };
}

export interface AddPasswordFailed {
  type: Constants.ADD_PASSWORD_FAILED;
}

export interface AddLicense {
  type: Constants.ADD_LICENSE;
  payload: {
    license: License;
  };
}

export interface AddCertificate {
  type: Constants.ADD_CERTIFICATE;
  payload: {
    certificate: Certificate;
  };
}

export type CommonAction =
  | RequestLicenses
  | RequestLicensesSuccess
  | RequestLicensesFailed
  | RequestPasswords
  | RequestPasswordsSuccess
  | RequestPasswordsFailed
  | RequestCertificates
  | RequestCertificatesSuccess
  | RequestCertificatesFailed
  | AddPassword
  | AddPasswordSuccess
  | AddPasswordFailed
  | AddLicense
  | AddCertificate
  | RequestTenants
  | RequestTenantsSuccess
  | RequestTenantsFailed;

export const requestLicenses = (legacyOnly?: boolean): RequestLicenses => ({
  type: Constants.REQUEST_LICENSES,
  payload: { legacyOnly }
});

export const requestLicensesSuccess = (
  licenses: License[]
): RequestLicensesSuccess => ({
  type: Constants.REQUEST_LICENSES_SUCCESS,
  payload: { licenses }
});

export const requestLicensesFailed = (): RequestLicensesFailed => ({
  type: Constants.REQUEST_LICENSES_FAILED
});

export const requestPasswords = (): RequestPasswords => ({
  type: Constants.REQUEST_PASSWORDS
});

export const requestPasswordsSuccess = (
  passwords: Password[]
): RequestPasswordsSuccess => ({
  type: Constants.REQUEST_PASSWORDS_SUCCESS,
  payload: { passwords }
});

export const requestPasswordsFailed = (): RequestPasswordsFailed => ({
  type: Constants.REQUEST_PASSWORDS_FAILED
});

export const requestCertificates = (): RequestCertificates => ({
  type: Constants.REQUEST_CERTIFICATES
});

export const requestTenants = (
  environmentId: string,
  productId: string
): RequestTenants => ({
  type: Constants.REQUEST_TENANTS,
  payload: {
    environmentId,
    productId
  }
});

export const requestTenantsSuccess = (
  tenants: string[]
): RequestTenantsSuccess => ({
  type: Constants.REQUEST_TENANTS_SUCCESS,
  payload: {
    tenants
  }
});

export const requestTenantsFailed = (): RequestTenantsFailed => ({
  type: Constants.REQUEST_TENANTS_FAILED
});

export const requestCertificatesSuccess = (
  certificates: AliasVmid[]
): RequestCertificatesSuccess => ({
  type: Constants.REQUEST_CERTIFICATES_SUCCESS,
  payload: { certificates }
});

export const requestCertificatesFailed = (): RequestCertificatesFailed => ({
  type: Constants.REQUEST_CERTIFICATES_FAILED
});

export const addPassword = (password: Password): AddPassword => ({
  payload: { password },
  type: Constants.ADD_PASSWORD
});

export const addPasswordSuccess = (password: Password): AddPasswordSuccess => ({
  type: Constants.ADD_PASSWORD_SUCCESS,
  payload: { password }
});

export const addPasswordFailed = (): AddPasswordFailed => ({
  type: Constants.ADD_PASSWORD_FAILED
});

export const addLicense = (license: License): AddLicense => ({
  payload: { license },
  type: Constants.ADD_LICENSE
});

export const addCertificate = (certificate: Certificate): AddCertificate => ({
  payload: { certificate },
  type: Constants.ADD_CERTIFICATE
});
